module.exports = __webpack_public_path__ + "static/image/sustainability/pc/ethical.ver2_0_2.jpg?c912bebd";